<template>
    <Question question="What is your relationship to the Veteran?" :can-go-back="false">
        <div class="form-group">
            <div class="input-group">
                <select class="form-control" v-model="relationship">
                    <option value="Self">I am the Veteran</option>
                    <option value="Spouse">I am the Veteran's spouse</option>
                    <option value="Child">I am the Veteran's child</option>
                    <option value="Parent">I am the Veteran's parent</option>
                </select>
            </div>
        </div>
    </Question>
</template>

<script>
import Question from './Question.vue'
export default {
  name: 'VeteranRelationship',
  components: {
      Question
  },
  data: function() {
    return {
        "relationship": "Self"
    };
  },
  created: function() {
    this.$on('save', function() {
        this.$parent.$emit('veteranRelationshipChanged', this.relationship);
    });
  }
}
</script>